__webpack_require__.p = "/legal/";